import React from 'react'
import { withTranslation } from 'react-i18next'
import styles from './styles.module.scss'

const NotAuthorizedErrorComponent = ({ t }) => {
  return <p className={styles.error}>{t('error.not_authorized')}</p>
}

const NotAuthorizedError = withTranslation('common')(NotAuthorizedErrorComponent)

export default NotAuthorizedError
